module.exports = __webpack_public_path__ + "static/img/bg.459d31a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/feature/bg.jpg
// module id = DmkO
// module chunks = 7